<template>
  <el-dialog :title="$t('enterprise::manager::editName')" :visible.sync="visible" width="500px">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('enterprise::manager::editName')" prop="userName">
        <el-input v-model="form.userName" :placeholder="$t('enterprise::manager::inputName')"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="" @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit" :loading="loading">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateMerchantName } from '@/server/user'
export default {
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        userName: ''
      },
      rules: {
        userName: [{ required: true, message: this.$t('enterprise::manager::inputName'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          const { data } = await updateMerchantName({
            name: this.form.userName,
            merchantId: this.form.userId
          })
          this.loading = false
          if (data.code === this.$code) {
            this.$message.success(this.$t('enterprise::manager::编辑成功'))
            this.$store.dispatch('getMerchant', true)
            this.visible = false
          }
        }
      })
    }
  },
  props: {
    value: {},
    editRow: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val && this.editRow.userId) {
        this.form = this.$deepClone(this.editRow)
      }
      if (!val) {
        this.form.userName = ''
        this.$refs.form.clearValidate()
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped lang="scss"></style>
